import { getCurrentOrgId } from 'client/modules/Auth/AuthReducer';

const prepareHeaders = (headers, { getState }) => {
  const orgId = getCurrentOrgId(getState());
  if (orgId) {
    headers.set('x-org', orgId);
  }
  return headers;
};

export default prepareHeaders;
